<ng-container *transloco="let t">

  <div class=" overflow-hidden relative flex flex-col h-full min-h-[480px] " (dragover)="onAreaDragOver($event)"
    (dragleave)="onAreaDragLeave($event)" (drop)="onAreaDrop($event)">

    @if(loading()) {
    <mat-progress-bar class="absolute! inset-x-0! top-0! h-0.5! z-20!" mode="indeterminate"></mat-progress-bar>
    }

    <!-- Toolbar -->
    <div class="flex flex-wrap items-center gap-2 px-3 py-2 border-b border-border">
      @if(!readonly()) {
      <button mat-flat-button color="primary" class="btn-block" [matMenuTriggerFor]="newMenu"
        [disabled]="loading()">
        {{ t('New') }}
      </button>


      <mat-menu #newMenu="matMenu">
        <button mat-menu-item (click)="newFolder()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:add-folder-linear"></i>
            <span>{{ t('New folder') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="pickFiles()">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:upload-linear"></i>
            <span>{{ t('Upload') }}</span>
          </div>
        </button>
      </mat-menu>
      <input #fileInput type="file" class="hidden" multiple (change)="onFilesSelected($event)" />

      }

      <div class="flex-1"></div>

      <mat-form-field appearance="outline" class="dense-field w-56" subscriptSizing="dynamic">
        <i matPrefix class="iconify text-lg ml-2 opacity-60" data-icon="solar:magnifer-linear"></i>
        <input matInput [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
          [placeholder]="t('Search in this folder')" />
        @if(searchText()) {
        <button matSuffix mat-icon-button (click)="searchText.set('')"><i class="iconify text-base"
            data-icon="solar:close-circle-linear"></i></button>
        }
      </mat-form-field>

      <button mat-icon-button [matMenuTriggerFor]="sortMenu" [matTooltip]="t('Sort by')">
        <span class="inline-flex transition-transform duration-150" [class.-scale-y-100]="!sortAsc()"><i
            class="iconify text-xl opacity-80" data-icon="solar:sort-from-top-to-bottom-linear"></i></span>
      </button>
      <mat-menu #sortMenu="matMenu">
        <button mat-menu-item (click)="setSort('name')">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:sort-by-alphabet-linear"></i>
            <span [class.font-semibold]="sortBy() === 'name'">{{ t('Name') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="setSort('size')">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:database-linear"></i>
            <span [class.font-semibold]="sortBy() === 'size'">{{ t('Size') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="setSort('date')">
          <div class="flex items-center gap-4">
            <i class="iconify text-2xl opacity-80" data-icon="solar:calendar-linear"></i>
            <span [class.font-semibold]="sortBy() === 'date'">{{ t('Modified') }}</span>
          </div>
        </button>
      </mat-menu>



      <mat-button-toggle-group    hideSingleSelectionIndicator [value]="viewMode()" (change)="setViewMode($event.value)">
        <mat-button-toggle value="list" [matTooltip]="t('List')"  class="flex items-center justify-center"><span class="flex items-center justify-center min-h-10"> <i class="iconify text-xl opacity-80"
            data-icon="solar:hamburger-menu-linear"></i></span></mat-button-toggle>
        <mat-button-toggle value="details" [matTooltip]="t('Details')"  class="flex items-center justify-center"><span class="flex items-center justify-center min-h-10"> <i class="iconify text-xl opacity-80"
            data-icon="solar:list-linear"></i></span></mat-button-toggle>
        <mat-button-toggle value="icons" [matTooltip]="t('Icons')"  class="flex items-center justify-center"><span class="flex items-center justify-center min-h-10"> <i class="iconify text-xl opacity-80"
            data-icon="solar:widget-4-linear"></i></span></mat-button-toggle>
        <mat-button-toggle value="tiles" [matTooltip]="t('Tiles')"  class="flex items-center justify-center"><span class="flex items-center justify-center min-h-10"> <i class="iconify text-xl opacity-80"
            data-icon="solar:widget-2-linear"></i></span></mat-button-toggle>
      </mat-button-toggle-group>

      <button mat-icon-button (click)="toggleDetails()" [matTooltip]="t('Details')"
        [class.text-primary]="detailsOpen()">
        <i class="iconify text-xl opacity-80" data-icon="solar:info-circle-linear"></i>
      </button>
      <button mat-icon-button (click)="load()" [disabled]="loading()">
        <i class="iconify text-xl opacity-80" data-icon="solar:refresh-outline"></i>
      </button>
    </div>

    <!-- Breadcrumb -->
    <div class="flex items-center gap-1 px-3 py-1.5 border-b border-border text-sm min-h-10 overflow-x-auto">
      @if(hasDrives()) {
      <button mat-icon-button class="scale-90 hidden md:inline-flex" (click)="toggleTree()"
        [matTooltip]="t('Navigation pane')">
        <i class="iconify text-lg" data-icon="solar:sidebar-minimalistic-linear"></i>
      </button>
      }
      <button mat-icon-button class="scale-90" (click)="goUp()" [disabled]="!crumbs().length" [matTooltip]="t('Back')">
        <i class="iconify text-lg" data-icon="solar:alt-arrow-left-linear"></i>
      </button>
      <button class="flex items-center gap-1 px-2 py-1 rounded-md hover:bg-light transition-colors"
        [class.bg-light-primary]="isDropTarget(null)" [class.font-semibold]="!crumbs().length" (click)="goToRoot()"
        (dragover)="onTargetDragOver($event, null)" (dragleave)="onTargetDragLeave()"
        (drop)="onTargetDrop($event, null)">
        <!-- O Iconify troca o <i> por <svg>; o span dá ao Angular um nó próprio para remover no @if/@for. -->
        @if(currentStorage(); as storage) {
        <span class="inline-flex"><i class="iconify text-lg text-primary" [attr.data-icon]="storageIcon(storage)"></i></span>{{ storage.name }}
        } @else {
        <span class="inline-flex"><i class="iconify text-lg text-amber-500" data-icon="solar:home-2-linear"></i></span>{{ t('Root') }}
        }
      </button>
      @for(crumb of crumbs(); track crumb.id; let i = $index; let last = $last) {
      <span class="inline-flex"><i class="iconify text-base opacity-50" data-icon="solar:alt-arrow-right-linear"></i></span>
      <button class="px-2 py-1 rounded-md hover:bg-light transition-colors truncate max-w-56"
        [class.bg-light-primary]="isDropTarget(crumb)" [class.font-semibold]="last" (click)="goToCrumb(i)"
        (dragover)="onTargetDragOver($event, crumb)" (dragleave)="onTargetDragLeave()"
        (drop)="onTargetDrop($event, crumb)">
        {{ crumb.name }}
      </button>
      }
    </div>

    <!-- Upload progress -->
    @if(uploadService.progress(); as p) {
    <div class="px-4 py-2 border-b border-border text-xs flex items-center gap-3 bg-light/30">
      <i class="iconify text-base" data-icon="solar:upload-linear"></i>
      <span class="truncate flex-1">{{ p.fileName }}</span>
      <span class="text-muted-foreground">{{ t(p.stage) }}</span>
      <mat-progress-bar class="w-40 h-1!" mode="determinate" [value]="p.percent"
        [color]="p.stage === 'error' ? 'warn' : 'primary'"></mat-progress-bar>
    </div>
    }

    <!-- Corpo -->
    <div class="flex-1 min-h-0 flex">

      <!-- Árvore: Root > discos (storages) > pastas -->
      @if(hasDrives() && treeOpen()) {
      <div class="w-64 shrink-0 border-r border-border hidden md:flex flex-col select-none">
        <!-- <div class="px-3 py-2 border-b border-border flex items-center gap-2 text-sm font-medium">
        <i class="iconify text-lg text-primary" data-icon="solar:monitor-linear"></i>{{ t('This Computer') }}
      </div> -->
        <ng-scrollbar class="flex-1 min-h-0">
          <div class="">
            @for(node of treeNodes(); track node.id) {
            <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: node, depth: 0 }"></ng-container>
            }
          </div>
        </ng-scrollbar>
        @if(currentStorage(); as storage) {
        <div class="px-3 py-2 border-t border-border text-[11px] text-muted-foreground">
          <div class="flex items-center justify-between mb-1">
            <span class="truncate">{{ storage.name }}</span>
            <span>{{ formatBytes(storage.usedBytes) }} / {{ formatBytes(storage.totalBytes) }}</span>
          </div>
          <mat-progress-bar mode="determinate" [value]="storageUsagePercent(storage)"
            [color]="storageUsagePercent(storage) > 90 ? 'warn' : 'primary'" class="h-1!"></mat-progress-bar>
        </div>
        }
      </div>
      }

      <div class="flex-1 min-w-0 relative flex flex-col" (contextmenu)="onContextMenu($event)">
        @if(dragOverArea()) {
        <div
          class="absolute inset-2 z-10 rounded-md border-2 border-dashed border-primary bg-light-primary/60 flex items-center justify-center pointer-events-none">
          <div class="flex flex-col items-center gap-2 text-primary">
            <i class="iconify text-5xl" data-icon="solar:cloud-upload-linear"></i>
            <span class="text-sm font-medium">{{ t('Drop files here to upload') }}</span>
          </div>
        </div>
        }

        <ng-scrollbar class="flex-1 min-h-0">
          @if(!items().length && !loading()) {
          <div class="p-10 flex flex-col items-center gap-3 text-muted-foreground">
            <i class="iconify text-6xl opacity-40" data-icon="solar:folder-outline"></i>
            <span class="text-sm">{{ searchText() ? t('Nothing found') : t('This folder is empty') }}</span>
            @if(!readonly() && !searchText()) { <span class="text-xs">{{ t('Drop files here or use the Upload button')
              }}</span> }
          </div>
          } @else {

          <!-- ===== Detalhes (tabela) ===== -->
          @switch(viewMode()) {
          @case('details') {
          <table class="w-full text-sm select-none">
            <thead class="text-muted-foreground text-xs sticky top-0 z-[1]">
              <tr class="border-b border-border">
                <th class="text-left px-4 py-2 font-normal cursor-pointer" (click)="setSort('name')">{{ t('Name') }}
                </th>
                <th class="text-left px-2 py-2 font-normal hidden md:table-cell">{{ t('Type') }}</th>
                <th class="text-right px-2 py-2 font-normal cursor-pointer" (click)="setSort('size')">{{ t('Size') }}
                </th>
                <th class="text-left px-2 py-2 font-normal hidden lg:table-cell cursor-pointer"
                  (click)="setSort('date')">{{ t('Modified') }}</th>
                <th class="text-left px-2 py-2 font-normal hidden lg:table-cell">{{ t('Status') }}</th>
                <th class="w-10 px-2 py-2"></th>
              </tr>
            </thead>
            <tbody>
              @for(item of items(); track item.id) {
              <tr class="border-b border-border/60 cursor-pointer transition-colors hover:bg-light/60"
                [class.bg-light-primary]="selected()?.id === item.id || (item.kind === 'folder' && isDropTarget(item.folder!))"
                draggable="true" (dragstart)="onItemDragStart($event, item)" (dragend)="onItemDragEnd()"
                (dragover)="item.kind === 'folder' && onTargetDragOver($event, item.folder!)"
                (dragleave)="item.kind === 'folder' && onTargetDragLeave()"
                (drop)="item.kind === 'folder' && onTargetDrop($event, item.folder!)" (click)="select(item)"
                (dblclick)="open(item)" (contextmenu)="item.kind === 'folder' && onContextMenu($event, item.folder!)">
                <td class="px-4 py-2">
                  <div class="flex items-center gap-2 min-w-0">
                    <i class="iconify text-xl shrink-0" [ngClass]="iconColor(item)" [attr.data-icon]="item.icon"></i>
                    <span class="truncate">{{ item.name }}</span>
                    @if(item.kind === 'file' && (item.file?.version ?? 1) > 1) { <span
                      class="text-[10px] text-muted-foreground">v{{ item.file?.version }}</span> }
                  </div>
                </td>
                <td class="px-2 py-2 hidden md:table-cell text-muted-foreground">{{ item.typeName }}</td>
                <td class="px-2 py-2 text-right text-muted-foreground whitespace-nowrap">
                  @if(item.kind === 'folder') { {{ item.folder?.totalFileCount }} {{ t('Items') | lowercase }} · }{{
                  formatBytes(item.sizeBytes) }}
                </td>
                <td class="px-2 py-2 hidden lg:table-cell text-muted-foreground whitespace-nowrap">{{ item.date |
                  date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="px-2 py-2 hidden lg:table-cell">@if(item.kind === 'file') { <app-status-badge-sm
                    [status]="item.file?.status"></app-status-badge-sm> }</td>
                <td class="px-2 py-2 text-right">
                  <ng-container *ngTemplateOutlet="itemMenuButton; context: { $implicit: item }"></ng-container>
                </td>
              </tr>
              }
            </tbody>
          </table>
          }

          <!-- ===== Lista compacta ===== -->
          @case('list') {
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-4 px-2 py-1 select-none">
            @for(item of items(); track item.id) {
            <div
              class="flex items-center gap-2 px-2 py-1.5 rounded-md cursor-pointer transition-colors hover:bg-light/60 min-w-0"
              [class.bg-light-primary]="selected()?.id === item.id || (item.kind === 'folder' && isDropTarget(item.folder!))"
              draggable="true" (dragstart)="onItemDragStart($event, item)" (dragend)="onItemDragEnd()"
              (dragover)="item.kind === 'folder' && onTargetDragOver($event, item.folder!)"
              (dragleave)="item.kind === 'folder' && onTargetDragLeave()"
              (drop)="item.kind === 'folder' && onTargetDrop($event, item.folder!)" (click)="select(item)"
              (dblclick)="open(item)" (contextmenu)="item.kind === 'folder' && onContextMenu($event, item.folder!)">
              <i class="iconify text-lg shrink-0" [ngClass]="iconColor(item)" [attr.data-icon]="item.icon"></i>
              <span class="truncate text-sm flex-1">{{ item.name }}</span>
              <span class="text-xs text-muted-foreground whitespace-nowrap">{{ formatBytes(item.sizeBytes) }}</span>
              <ng-container *ngTemplateOutlet="itemMenuButton; context: { $implicit: item }"></ng-container>
            </div>
            }
          </div>
          }

          <!-- ===== Ícones ===== -->
          @case('icons') {
          <div class="p-3 select-none">
            @if(folderItems().length) {
            <div class="text-xs text-muted-foreground mb-2 px-1">{{ t('Folders') }}</div>
            <div class="grid grid-cols-[repeat(auto-fill,minmax(110px,1fr))] gap-1 mb-4">
              @for(item of folderItems(); track item.id) {
              <ng-container *ngTemplateOutlet="iconCell; context: { $implicit: item }"></ng-container>
              }
            </div>
            }
            @if(fileItems().length) {
            <div class="text-xs text-muted-foreground mb-2 px-1">{{ t('Files') }}</div>
            <div class="grid grid-cols-[repeat(auto-fill,minmax(110px,1fr))] gap-1">
              @for(item of fileItems(); track item.id) {
              <ng-container *ngTemplateOutlet="iconCell; context: { $implicit: item }"></ng-container>
              }
            </div>
            }
          </div>
          }

          <!-- ===== Blocos ===== -->
          @case('tiles') {
          <div class="p-3 select-none">
            @if(folderItems().length) {
            <div class="text-xs text-muted-foreground mb-2 px-1">{{ t('Folders') }}</div>
            <div class="grid grid-cols-[repeat(auto-fill,minmax(210px,1fr))] gap-3 mb-5">
              @for(item of folderItems(); track item.id) {
              <div
                class="group border border-border rounded-xl px-3 py-2.5 flex items-center gap-3 cursor-pointer transition-colors hover:bg-light/60"
                [class.bg-light-primary]="selected()?.id === item.id || isDropTarget(item.folder!)"
                [class.border-primary]="selected()?.id === item.id" draggable="true"
                (dragstart)="onItemDragStart($event, item)" (dragend)="onItemDragEnd()"
                (dragover)="onTargetDragOver($event, item.folder!)" (dragleave)="onTargetDragLeave()"
                (drop)="onTargetDrop($event, item.folder!)" (click)="select(item)" (dblclick)="open(item)"
                (contextmenu)="onContextMenu($event, item.folder!)">
                <i class="iconify text-3xl shrink-0" [ngClass]="iconColor(item)" [attr.data-icon]="item.icon"></i>
                <div class="min-w-0 flex-1">
                  <div class="text-sm truncate">{{ item.name }}</div>
                  <div class="text-[11px] text-muted-foreground truncate">{{ item.folder?.totalFileCount }} {{
                    t('Items') | lowercase }} · {{ formatBytes(item.sizeBytes) }}</div>
                </div>
                <ng-container *ngTemplateOutlet="itemMenuButton; context: { $implicit: item }"></ng-container>
              </div>
              }
            </div>
            }
            @if(fileItems().length) {
            <div class="text-xs text-muted-foreground mb-2 px-1">{{ t('Files') }}</div>
            <div class="grid grid-cols-[repeat(auto-fill,minmax(210px,1fr))] gap-3">
              @for(item of fileItems(); track item.id) {
              <div
                class="group border border-border rounded-xl overflow-hidden cursor-pointer transition-colors hover:bg-light/60"
                [class.bg-light-primary]="selected()?.id === item.id"
                [class.border-primary]="selected()?.id === item.id" draggable="true"
                (dragstart)="onItemDragStart($event, item)" (dragend)="onItemDragEnd()" (click)="select(item)"
                (dblclick)="open(item)">
                <div class="h-28 flex items-center justify-center bg-light/50">
                  <i class="iconify text-6xl" [ngClass]="iconColor(item)" [attr.data-icon]="item.icon"></i>
                </div>
                <div class="px-3 py-2 flex items-center gap-2">
                  <div class="min-w-0 flex-1">
                    <div class="text-sm truncate" [matTooltip]="item.name">{{ item.name }}</div>
                    <div class="text-[11px] text-muted-foreground truncate">{{ item.typeName }} · {{
                      formatBytes(item.sizeBytes) }}</div>
                  </div>
                  <ng-container *ngTemplateOutlet="itemMenuButton; context: { $implicit: item }"></ng-container>
                </div>
              </div>
              }
            </div>
            }
          </div>
          }
          }
          }
        </ng-scrollbar>

        <!-- Paginação: pastas e arquivos contam juntos, no máximo pageSize itens por página -->
        @if(totalCount() > pageSize) {
        <div class="shrink-0 border-t border-border px-3 py-1.5 flex items-center justify-end gap-2 text-xs text-muted-foreground">
          <span class="leading-none">{{ pageStart() }}–{{ pageEnd() }} {{ t('of') }} {{ totalCount() }}</span>
          <button type="button" mat-icon-button class="h-7! w-7! flex! items-center! justify-center!"
            [disabled]="page() <= 1" [matTooltip]="t('Previous page')" (click)="goToPage(page() - 1)">
            <span class="inline-flex"><i class="iconify text-base" data-icon="solar:alt-arrow-left-linear"></i></span>
          </button>
          <span class="leading-none">{{ page() }} / {{ pageCount() }}</span>
          <button type="button" mat-icon-button class="h-7! w-7! flex! items-center! justify-center!"
            [disabled]="page() >= pageCount()" [matTooltip]="t('Next page')" (click)="goToPage(page() + 1)">
            <span class="inline-flex"><i class="iconify text-base" data-icon="solar:alt-arrow-right-linear"></i></span>
          </button>
        </div>
        }
      </div>

      <!-- Painel de detalhes -->
      @if(detailsOpen()) {
      <div class="w-80 shrink-0 border-l border-border hidden md:flex flex-col">
        <div class="px-4 py-2 border-b border-border flex items-center gap-2">
          <span class="text-sm font-medium flex-1">{{ t('Details') }}</span>
          <button mat-icon-button class="scale-90" (click)="toggleDetails()" [matTooltip]="t('Close details')">
            <i class="iconify text-lg" data-icon="solar:close-circle-linear"></i>
          </button>
        </div>
        <ng-scrollbar class="flex-1 min-h-0">
          @if(selected(); as item) {
          <div class="p-4 text-sm">
            <div class="flex flex-col items-center gap-2 mb-4">
              <!-- O Iconify troca o <i> por <svg> uma única vez; o @for chaveado pelo ícone recria o nó a cada seleção. -->
              @for(icon of [item.icon]; track icon) {
              <span class="inline-flex"><i class="iconify text-7xl" [ngClass]="iconColor(item)" [attr.data-icon]="icon"></i></span>
              }
              <div class="font-medium text-center break-all">{{ item.name }}</div>
              <div class="text-xs text-muted-foreground">{{ item.typeName }}</div>
            </div>

            <dl class="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1.5 text-xs">
              @if(item.kind === 'folder') {
              <dt class="text-muted-foreground">{{ t('Path') }}</dt>
              <dd class="break-all">{{ item.folder?.displayPath }}</dd>
              <dt class="text-muted-foreground">{{ t('Subfolders') }}</dt>
              <dd>{{ item.folder?.folderCount }}</dd>
              <dt class="text-muted-foreground">{{ t('Files in this folder') }}</dt>
              <dd>{{ item.folder?.fileCount }} · {{ formatBytes(item.folder?.sizeBytes) }}</dd>
              <dt class="text-muted-foreground">{{ t('Files in subtree') }}</dt>
              <dd>{{ item.folder?.totalFileCount }}</dd>
              <dt class="text-muted-foreground">{{ t('Size in subtree') }}</dt>
              <dd>{{ formatBytes(item.folder?.totalSizeBytes) }}</dd>
              <dt class="text-muted-foreground">{{ t('Description') }}</dt>
              <dd>{{ item.folder?.description || '—' }}</dd>
              <dt class="text-muted-foreground">{{ t('Created by') }}</dt>
              <dd>{{ item.folder?.log?.createdBy?.name || '—' }}</dd>
              <dt class="text-muted-foreground">{{ t('Created at') }}</dt>
              <dd>{{ item.folder?.log?.createdAt | date:'dd/MM/yyyy HH:mm' }}</dd>
              } @else {
              <dt class="text-muted-foreground">{{ t('Status') }}</dt>
              <dd><app-status-badge-sm [status]="item.file?.status"></app-status-badge-sm></dd>
              <dt class="text-muted-foreground">{{ t('Size') }}</dt>
              <dd>{{ formatBytes(item.file?.sizeBytes) }}</dd>
              <dt class="text-muted-foreground">{{ t('Type') }}</dt>
              <dd>{{ item.typeName }}</dd>
              <dt class="text-muted-foreground">MIME</dt>
              <dd class="break-all">{{ item.file?.contentType }}</dd>
              <dt class="text-muted-foreground">{{ t('Version') }}</dt>
              <dd>v{{ item.file?.version }}</dd>
              <dt class="text-muted-foreground">{{ t('Storage') }}</dt>
              <dd>{{ item.file?.storage?.name }}</dd>
              <dt class="text-muted-foreground">{{ t('File Key') }}</dt>
              <dd class="break-all">{{ item.file?.key }}</dd>
              <dt class="text-muted-foreground">{{ t('Group') }}</dt>
              <dd>{{ item.file?.group?.name || '—' }}</dd>
              <dt class="text-muted-foreground">{{ t('Origin') }}</dt>
              <dd>{{ item.file?.origin?.name || '—' }}</dd>
              <dt class="text-muted-foreground">{{ t('Visibility') }}</dt>
              <dd>{{ item.file?.visibility?.name || '—' }}</dd>
              @if(item.file?.publicUrl) {
              <dt class="text-muted-foreground">{{ t('Public URL') }}</dt>
              <dd class="break-all">
                <a class="text-primary hover:underline" [href]="item.file!.publicUrl" target="_blank"
                  rel="noopener">{{ item.file!.publicUrl }}</a>
                <button type="button" mat-icon-button class="h-6! w-6! ml-1 align-middle"
                  [matTooltip]="t('Copy URL')" (click)="copyPublicUrl(item.file!)">
                  <i class="iconify text-base" data-icon="solar:copy-linear"></i>
                </button>
              </dd>
              }
              <dt class="text-muted-foreground">{{ t('Description') }}</dt>
              <dd>{{ item.file?.description || '—' }}</dd>
              <dt class="text-muted-foreground">{{ t('Uploaded') }}</dt>
              <dd>{{ item.file?.log?.createdAt | date:'dd/MM/yyyy HH:mm' }}</dd>
              <dt class="text-muted-foreground">{{ t('Created by') }}</dt>
              <dd>{{ item.file?.log?.createdBy?.name || '—' }}</dd>
              }
            </dl>

            <div class="flex flex-wrap gap-2 mt-4">
              @if(item.kind === 'file' && canDownload(item.file!)) {
              <button mat-stroked-button class="h-8!" (click)="download(item.file!)"><span
                  class="inline-flex items-center gap-1"><i class="iconify text-base"
                    data-icon="solar:download-linear"></i>{{ t('Download') }}</span></button>
              }
              @if(item.kind === 'folder') {
              <button mat-stroked-button class="h-8!" (click)="openFolder(item.folder!)"><span
                  class="inline-flex items-center gap-1"><i class="iconify text-base"
                    data-icon="solar:folder-outline"></i>{{ t('Open') }}</span></button>
              }
              @if(!readonly() && !isSystemItem(item)) {
              <button mat-stroked-button class="h-8!" (click)="renameItem(item)"><span
                  class="inline-flex items-center gap-1"><i class="iconify text-base"
                    data-icon="solar:pen-linear"></i>{{ t('Rename') }}</span></button>
              }
            </div>
          </div>
          } @else {
          <div class="p-6 text-center text-xs text-muted-foreground">
            <div class="mb-3">{{ t('Select an item to see its details') }}</div>
            <div class="text-left border-t border-border pt-3 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
              <span>{{ t('Folders') }}</span><span class="text-right">{{ folders().length }}</span>
              <span>{{ t('Files') }}</span><span class="text-right">{{ files().length }}</span>
              <span>{{ t('Size') }}</span><span class="text-right">{{ formatBytes(totalSizeBytes()) }}</span>
            </div>
          </div>
          }
        </ng-scrollbar>
      </div>
      }
    </div>

    <!-- Rodapé -->
    <div class="px-4 py-1.5 border-t border-border text-[11px] text-muted-foreground flex items-center gap-4">
      <span>{{ folders().length }} {{ t('Folders') | lowercase }}</span>
      <span>{{ files().length }} {{ t('Files') | lowercase }}</span>
      <span>{{ formatBytes(totalSizeBytes()) }}</span>
      @if(selected(); as item) { <span class="ml-auto truncate">{{ item.name }}</span> }
    </div>
  </div>

  <!-- Nó da árvore (recursivo): disco ou pasta -->
  <ng-template #treeNode let-node let-depth="depth">
    <div
      class="flex items-center gap-1 pr-2 py-1  cursor-pointer transition-colors hover:bg-light/60 text-sm min-w-0"
      [style.padding-left.px]="8 + depth * 14"
      [class.bg-light-primary]="isNodeSelected(node) || (node.folder && isDropTarget(node.folder))"
      [class.font-medium]="isNodeSelected(node)" (click)="selectNode(node)"
      (contextmenu)="onNodeContextMenu($event, node)"
      (dragover)="onTargetDragOver($event, node.folder)" (dragleave)="onTargetDragLeave()"
      (drop)="onTargetDrop($event, node.folder)">
      <button class="w-5 h-5 flex items-center justify-center rounded hover:bg-light shrink-0"
        (click)="$event.stopPropagation(); toggleNode(node)">
        @if(node.loading) {
        <mat-spinner diameter="12"></mat-spinner>
        } @else if(node.children === null || node.children.length) {
        <!-- Girar por CSS em vez de trocar data-icon: o Iconify substitui o <i> por <svg> e não reage a mudanças no atributo. -->
        <span class="inline-flex transition-transform duration-150" [class.rotate-90]="node.expanded"><i
            class="iconify text-base opacity-70" data-icon="solar:alt-arrow-right-linear"></i></span>
        }
      </button>
      @if(node.kind === 'storage') {
      <span class="inline-flex shrink-0"><i class="iconify text-lg text-primary" [attr.data-icon]="storageIcon(node.storage)"></i></span>
      } @else {
      <span class="inline-flex shrink-0"><i class="iconify text-lg" [ngClass]="folderColor(node.folder)"
        data-icon="solar:folder-outline"></i></span>
      }
      <span class="truncate">{{ node.name }}</span>
      @if(node.kind === 'storage' && node.storage.status?.key && node.storage.status?.key !== 'active') {
      <span class="inline-flex ml-auto shrink-0" [matTooltip]="node.storage.status?.name ?? ''"><i class="iconify text-sm text-warning"
        data-icon="solar:lock-keyhole-minimalistic-linear"></i></span>
      }
    </div>
    @if(node.expanded && node.children?.length) {
    @for(child of node.children; track child.id) {
    <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: child, depth: depth + 1 }"></ng-container>
    }
    }
  </ng-template>

  <!-- Célula de ícone (modo Ícones) -->
  <ng-template #iconCell let-item>
    <div
      class="flex flex-col items-center gap-1 p-2 rounded-lg cursor-pointer transition-colors hover:bg-light/60 relative group"
      [class.bg-light-primary]="selected()?.id === item.id || (item.kind === 'folder' && isDropTarget(item.folder))"
      draggable="true" (dragstart)="onItemDragStart($event, item)" (dragend)="onItemDragEnd()"
      (dragover)="item.kind === 'folder' && onTargetDragOver($event, item.folder)"
      (dragleave)="item.kind === 'folder' && onTargetDragLeave()"
      (drop)="item.kind === 'folder' && onTargetDrop($event, item.folder)" (click)="select(item)"
      (dblclick)="open(item)" (contextmenu)="item.kind === 'folder' && onContextMenu($event, item.folder)"
      [matTooltip]="item.name">
      <i class="iconify text-5xl" [ngClass]="iconColor(item)" [attr.data-icon]="item.icon"></i>
      <span class="text-xs text-center leading-tight line-clamp-2 break-all w-full">{{ item.name }}</span>
      <div class="absolute top-0 right-0 opacity-0 group-hover:opacity-100 transition-opacity">
        <ng-container *ngTemplateOutlet="itemMenuButton; context: { $implicit: item }"></ng-container>
      </div>
    </div>
  </ng-template>

  <!-- Menu de contexto por item -->
  <ng-template #itemMenuButton let-item>
    <button mat-icon-button class="scale-75!" [matMenuTriggerFor]="itemMenu" [matMenuTriggerData]="{ item: item }"
      (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
      <i class="iconify text-xl" data-icon="solar:menu-dots-bold"></i>
    </button>
  </ng-template>

  <mat-menu #itemMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="open(item)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80"
            [attr.data-icon]="item.kind === 'folder' ? 'solar:folder-outline' : 'solar:download-linear'"></i>
          <span>{{ item.kind === 'folder' ? t('Open') : t('Download') }}</span>
        </div>
      </button>
      <button mat-menu-item (click)="select(item); detailsOpen.set(true)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:info-circle-linear"></i>
          <span>{{ t('Details') }}</span>
        </div>
      </button>
      @if(!readonly()) {
      <mat-divider></mat-divider>
      @if(!isSystemItem(item)) {
      <button mat-menu-item (click)="renameItem(item)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:pen-linear"></i>
          <span>{{ t('Rename') }}</span>
        </div>
      </button>
      }
      @if(!isSystemItem(item)) {
      <button mat-menu-item [matMenuTriggerFor]="moveMenu" [matMenuTriggerData]="{ item: item }"
        (menuOpened)="loadTree()">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:move-to-folder-linear"></i>
          <span>{{ t('Move to') }}</span>
        </div>
      </button>
      }
      @if(canDeleteItem(item)) {
      <mat-divider></mat-divider>
      <button mat-menu-item class="text-red-600!" (click)="deleteItem(item)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:trash-bin-trash-linear"></i>
          <span>{{ t('Delete') }}</span>
        </div>
      </button>
      }
      }
    </ng-template>
  </mat-menu>

  <mat-menu #moveMenu="matMenu" class="max-h-96">
    <ng-template matMenuContent let-item="item">
      <div class="px-4 py-1 text-[11px] text-muted-foreground">{{ t('Choose the destination folder') }}</div>
      <button mat-menu-item (click)="moveItem(item, null)" [disabled]="!canMoveTo(item, null)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:home-2-linear"></i>
          <span>{{ t('Root') }}</span>
        </div>
      </button>
      @for(target of tree(); track target.id) {
      <button mat-menu-item (click)="moveItem(item, target)"
        [disabled]="target.id === item.id || !canMoveTo(item, target)"
        [style.padding-left.px]="16 + (target.depth ?? 0) * 14">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:folder-outline"></i>
          <span>{{ target.name }}</span>
        </div>
      </button>
      }
    </ng-template>
  </mat-menu>

  <!-- Menu de contexto (botão direito): âncora invisível posicionada no ponto do clique -->
  <div class="fixed w-0 h-0" [style.left.px]="contextMenuPosition().x" [style.top.px]="contextMenuPosition().y"
    #folderContextTrigger="matMenuTrigger" [matMenuTriggerFor]="folderContextMenu"></div>

  <mat-menu #folderContextMenu="matMenu">
    <ng-template matMenuContent>
      @if(contextTarget(); as target) {
      <div class="px-4 py-1 text-[11px] text-muted-foreground truncate max-w-64">
        {{ target.folder?.name ?? target.storage?.name ?? t('Root') }}
      </div>
      <button mat-menu-item (click)="pickFiles(target)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:upload-linear"></i>
          <span>{{ t('Upload') }}</span>
        </div>
      </button>
      <button mat-menu-item (click)="newFolder(target)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:add-folder-linear"></i>
          <span>{{ t('New folder') }}</span>
        </div>
      </button>
      @if(target.folder && !isProtectedFolder(target.folder)) {
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="renameFolder(target.folder)">
        <div class="flex items-center gap-4">
          <i class="iconify text-2xl opacity-80" data-icon="solar:pen-linear"></i>
          <span>{{ t('Rename') }}</span>
        </div>
      </button>
      }
      }
    </ng-template>
  </mat-menu>
</ng-container>
